/**
 * Room split: one user-drawn wall that SPANS its room turns that room into
 * two. The inverse of `shared-lib/room-merge` + `functions/features/room-merge.js`,
 * and deliberately built on the same primitives — which is also what gives the
 * split an undo for free: demolishing the partition routes through
 * `findMergeForWall` → `mergeRoomsAcrossWall` and the two rooms become one
 * again through code that is already shipped and tested.
 *
 * This module is the PURE half (eligibility, polygons, membership). The
 * orchestration that needs the pipeline's floor/ceiling builders lives in
 * `functions/features/room-split.js`, exactly as the merge splits its engine
 * between shared-lib and functions.
 *
 * See reference-docs/room-split/overview.md.
 */

module.exports = {
  ...require('./chain'),
  ...require('./detect'),
  ...require('./chainCut'),
  ...require('./evidence'),
  ...require('./regions-remap'),
  ...require('./records'),
  ...require('./satellites'),
  ...require('./regions'),
  ...require('./geometry'),
  ...require('./overlap'),
  ...require('./pointPiece'),
  ...require('./walls'),
  ...require('./assign'),
  ...require('./extend'),
  ...require('./ceilings'),
};
